
























































































































import Vue from 'vue'
import { ProductionPlanProcessDTO } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { ProcessServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { convertSeconds, isDisplayShow } from '@/utils/index'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import * as _ from 'lodash'

const ONE_DAY = 60 * 60 * 24;
const ONE_HOUR = 60 * 60;
const ONE_MINUTE = 60;
const processServiceProxy = new ProcessServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()

export default Vue.extend({
  data() {
    return {
      // 当前正在编辑的行，为index 也就是sort-1
      editCol: '',
      processList: [],
      editObj: {
        standardTime: {
          day: 0,
          hour: 0,
          minute: 0,
          second: 0
        }
      },
      productColums: [], // 产品表格的字段
      showColumns: [],
      // 被编辑的元数据
      sourceEditObj: {},
      selectedRowKeys: [],
      programList: [], // 程序列表
      // 是input框的输入列表
      inputList: [],
      // input是数字输入列表
      inputNumberList: [],
      fetching: false, // 筛选工序编号/名称的状态
      lastFetchId: 0
    }
  },

  created() {
    this.getTableColumn()
  },
  props: {
    addFlag: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    fileList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    rowSelection() {
      if (this.addFlag) {
        return {
          selectedRowKeys: this.selectedRowKeys,
          type: 'radio',
          onChange: this.onSelectChange
        }
      } else {
        return null
      }
    },
    searchProcessList2 () {
      return  _.debounce(this.searchProcessList, 800)
    }
  },
  watch: {
    data (val) {
      if (this.addFlag && val.length > 0) {
        this.selectedRowKeys = [val[0].code]
        this.$emit('chooseSort', val[0].sort)
      }
    }
  },
  methods: {
    convertSeconds,
    // 获取指定业务的字段列表
    getPageProcess() {
      const filterStatusList = {statusList: [1]} as any
      processServiceProxy.getPageProcess(1,filterStatusList, '', 9999).then(res => {
        this.processList = res.records
      })
    },
    async getTableColumn() {
      this.productColums = []
      this.productColums = await tenantBizFieldServiceProxy.getTenantBizField('plan_process', this.$route.path[this.$route.path.length - 1])
      this.handleColumns()
    },
    deleteRecord(record) {
      if (this.editCol !== '') {
        this.$message.info(this.$t('page_work_process_tip'))
        return 
      }
      // 删除
      this.data.splice(record.sort - 1, 1)
      // 重新开始排序
      this.data.forEach((res, index) => {
        res.sort = index + 1
      })
    },
    handleColumns() {
      this.showColumns = []
      if (!this.productColums || !this.productColums.length) {
        return
      }
      // 字段排序
      this.productColums.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = [{
        title: this.$t('page_batch_management_action'),
        dataIndex: 'operation',
        key: 'operation',
        scopedSlots: {customRender: 'operation'},
        ellipsis: true,
        fixed: true,
        width: 120,
      }]
      const scopedSlots = ['operation', 'code', 'name', 'programName', 'standardTime','processSequence']
      const inputList = ['extend1', 'extend2', 'extend3', 'extend4', 'extend5']
      const inputNumberList = ['disassemblyTime', 'prepareTime', 'transportTime']
      this.productColums.map(item => {
        if (isDisplayShow(item.isDisplay, 3)) {
          // 自定义字段：产品类型
          const temp: any = {
            title: item.title,
            key: item.code,
            dataIndex: item.code,
            ellipsis: true
          }
          if (temp.key === 'code' || temp.key === 'standardTime' || temp.key === 'programName') {
            temp.width = 200
          } else if (temp.key === 'name' ) {
            temp.width = 150
          } else {
            temp.width = (temp.title.length + 1) * 20
            if (inputList.includes(temp.key)) {
              this.inputList.push(temp.key)
              temp.scopedSlots = { customRender: temp.key }
            }
            if (inputNumberList.includes(temp.key)) {
              this.inputNumberList.push(temp.key)
              temp.scopedSlots = { customRender: temp.key }
            }
          }
          if (scopedSlots.includes(temp.key)) {
            temp.scopedSlots = { customRender: temp.key }
          }
          columns.push(temp)
        }
      })
      this.showColumns = [...columns]
    },
    edit(record) {
      if (this.editCol !== '') {
        this.$message.info('请先完成其余行的操作')
        return 
      }
      this.sourceEditObj = {...record}
      this.editCol = record.sort - 1
      this.emitEditCol()
      this.editObj = {
        code: record.code,
        name: record.name,
        processSequence: record.processSequence,
        programName: record.programName,
        sort: record.sort,
        editable: true,
        prepareTime: record.prepareTime,
        transportTime: record.transportTime,
        disassemblyTime: record.disassemblyTime,
        standardTime: this.covertStardTime(record.standardTime)
      }
      this.data.splice(record.sort - 1, 1, this.editObj)
      this.getPageProcess()
    },
    emitEditCol() {
      this.$emit('editCol', this.editCol)
    },
    check() {
      if (!this.editObj.code) {
        this.$message.error(this.$t('page_product_please_select_process_number'))
        return
      }
      const standardTime = this.covertStardTimeToSecond(this.editObj.standardTime)
      if (standardTime <= 0) {
        this.$message.error(this.$t('page_plan_work_procedure_tip2'))
        return
      }
      this.data[this.editCol].standardTime = standardTime
      this.data[this.editCol].disassemblyTime = this.covertHourToSecond(this.editObj.disassemblyTime)
      this.data[this.editCol].prepareTime = this.covertHourToSecond(this.editObj.prepareTime)
      this.data[this.editCol].transportTime = this.covertHourToSecond(this.editObj.transportTime)
      this.data[this.editCol].editable = false
      // 储存完数据清空编辑情况
      this.clearEditStatus()
      // 透传数据
      this.$emit('sendWpData', this.data)
    },
    clearEditStatus () {
      this.editCol = ''
      this.editObj = {}
      this.emitEditCol()
    },
    // 分转为s
    covertHourToSecond(hour) {
      return hour * 60
    },
    close(sort) {
      if (this.sourceEditObj) {
        this.data.splice(sort - 1, 1, this.sourceEditObj)
      } else {
        this.data.splice(sort - 1, 1)
      }
      this.clearEditStatus()
    },
    add() {
      this.sourceEditObj = null
      this.editObj = {
        code: '',
        name: '',
        programName: '',
        sort: this.data.length + 1,
        processSequence: this.data.length + 1,
        editable: true,
        standardTime: {
          day: 0,
          hour: 0,
          minute: 0,
          second: 0
        },
        disassemblyTime: 0,
        extend1: '',
        extend2: '',
			  extend3: '',
			  extend4: '',
			  extend5: '',
			  prepareTime: 0,
			  transportTime: 0
      }
      this.editCol = this.data.length
      this.emitEditCol()
      this.data.push(this.editObj)
      this.getPageProcess()
    },
    changeCode(processCode) {
      this.editObj.code = processCode
      this.editObj.name = (this.processList.find(res => res.code === processCode) || {}).name
    },
    selectProgram(programId) {
      this.editObj.programName = programId
    },
    // 把标准工时的秒 解析成天时分秒
    // type 为day hour minute second
    covertStardTime(num: number) {
      return {
        day: Math.trunc(num / ONE_DAY),
        hour: Math.trunc(num % ONE_DAY / ONE_HOUR),
        minute: Math.trunc(num % ONE_DAY % ONE_HOUR / ONE_MINUTE),
        second: Math.trunc(num % ONE_DAY % ONE_HOUR % ONE_MINUTE)
      }
    },
    covertStardTimeToSecond(standardTime = {day: 0, hour: 0, minute: 0, second: 0}) {
      return standardTime.day * ONE_DAY + standardTime.hour * ONE_HOUR + standardTime.minute * ONE_MINUTE + standardTime.second;
    },
    onSelectChange(keys, rows) {
      this.selectedRowKeys = keys
      this.$emit('chooseSort', rows[0].sort)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    async searchProcessList(keywords?: string) {
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      try {
        this.processList = []
        this.fetching = true
        let keyWords = keywords ? keywords : ''
        const filterStatusList = {statusList: [1]} as any
        const { records } = await processServiceProxy.getPageProcess(1, filterStatusList, keyWords, 999)
        if (fetchId !== this.lastFetchId) {
          this.fetching = false
          return;
        }
        this.processList = _.cloneDeep(records)
      } catch (e) {
      }
      this.fetching = false
    },
  }
})
